// extracted by mini-css-extract-plugin
export default {"section":"styles_section__xSeHR","table":"styles_table__TLi86","table__cell--home-room-section":"styles_table__cell--home-room-section__GrEox"};